import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"cols":"10","md":"11"}},[_c('Titles',{attrs:{"type":1,"text":'Presidentes'}}),(_vm.presidentsArray.length)?_c('VueSlickCarousel',_vm._b({staticClass:"queens-carrousel"},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.presidentsArray),function(president){return _c('Card',{key:president.id,staticClass:"queen-item",attrs:{"years":true,"disableOnClick":true,"card":president}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }